import styled from 'styled-components';
import { device } from '@/styles/template';

interface ImgProps {
	isSvg?: boolean; // Указание на тип изображения
}

export const Img = styled.img<ImgProps>`
	max-height: ${({ isSvg }) => (isSvg ? '10vh' : '50vh')};
	min-height: ${({ isSvg }) => (isSvg ? '10rem' : 'auto')};
	width: 100%;
	max-width: fit-content;
	height: auto;
	object-fit: fill;

  @media ${device.mobileL} {
    	max-height: ${({ isSvg }) => (isSvg ? '10vh' : '30vh')};
  }
`;
